// src/utils/localStorage.js

// Clés pour le localStorage
const STORAGE_KEYS = {
  USER_DECKS: 'elemental_duelists_user_decks',
  USER_COLLECTION: 'elemental_duelists_user_collection',
  USER_SETTINGS: 'elemental_duelists_user_settings',
  AUTH_TOKEN: 'elemental_duelists_auth_token',
  USER_PROFILE: 'elemental_duelists_user_profile'
};

// Fonction pour sauvegarder des données dans le localStorage
export const saveToLocalStorage = (key, data) => {
  try {
    const serializedData = JSON.stringify(data);
    localStorage.setItem(key, serializedData);
    return true;
  } catch (error) {
    console.error(`Error saving to localStorage [${key}]:`, error);
    return false;
  }
};

// Fonction pour récupérer des données du localStorage
export const getFromLocalStorage = (key, defaultValue = null) => {
  try {
    const serializedData = localStorage.getItem(key);
    if (serializedData === null) {
      return defaultValue;
    }
    return JSON.parse(serializedData);
  } catch (error) {
    console.error(`Error retrieving from localStorage [${key}]:`, error);
    return defaultValue;
  }
};

// Fonction pour supprimer des données du localStorage
export const removeFromLocalStorage = (key) => {
  try {
    localStorage.removeItem(key);
    return true;
  } catch (error) {
    console.error(`Error removing from localStorage [${key}]:`, error);
    return false;
  }
};

// Fonctions spécifiques pour les decks
export const saveUserDecks = (decks) => {
  return saveToLocalStorage(STORAGE_KEYS.USER_DECKS, decks);
};

export const getUserDecks = () => {
  return getFromLocalStorage(STORAGE_KEYS.USER_DECKS, []);
};

// Fonctions spécifiques pour la collection
export const saveUserCollection = (collection) => {
  return saveToLocalStorage(STORAGE_KEYS.USER_COLLECTION, collection);
};

export const getUserCollection = () => {
  return getFromLocalStorage(STORAGE_KEYS.USER_COLLECTION, []);
};

// Fonctions pour les paramètres utilisateur
export const saveUserSettings = (settings) => {
  return saveToLocalStorage(STORAGE_KEYS.USER_SETTINGS, settings);
};

export const getUserSettings = () => {
  return getFromLocalStorage(STORAGE_KEYS.USER_SETTINGS, {});
};

// Fonctions pour l'authentification
export const saveAuthToken = (token) => {
  return saveToLocalStorage(STORAGE_KEYS.AUTH_TOKEN, token);
};

export const getAuthToken = () => {
  return getFromLocalStorage(STORAGE_KEYS.AUTH_TOKEN, null);
};

export const removeAuthToken = () => {
  return removeFromLocalStorage(STORAGE_KEYS.AUTH_TOKEN);
};

// Fonctions pour le profil utilisateur
export const saveUserProfile = (profile) => {
  return saveToLocalStorage(STORAGE_KEYS.USER_PROFILE, profile);
};

export const getUserProfile = () => {
  return getFromLocalStorage(STORAGE_KEYS.USER_PROFILE, null);
};

// Exportation des constantes et fonctions
const localStorageUtils = {
  STORAGE_KEYS,
  saveToLocalStorage,
  getFromLocalStorage,
  removeFromLocalStorage,
  saveUserDecks,
  getUserDecks,
  saveUserCollection,
  getUserCollection,
  saveUserSettings,
  getUserSettings,
  saveAuthToken,
  getAuthToken,
  removeAuthToken,
  saveUserProfile,
  getUserProfile
};

export default localStorageUtils;